import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

/**
 * Environment-based discount configuration for rare products
 * This allows easy toggling of discounts per region without code changes
 */

export interface RareDiscountConfig {
  enabled: boolean;
  discountPercentage?: number;
  discountAmount?: number;
  showStrikedPrice?: boolean;
  description?: string;
}

export const getRareDiscountConfig = (): Record<
  ShopifyStore,
  RareDiscountConfig
> => {
  // Environment variable examples:
  // RARE_DISCOUNT_IN=true to enable discounts in India
  // RARE_DISCOUNT_US=true to enable discounts in US
  // RARE_SHOW_STRIKED_US=true to show striked prices in US
  // Default: All discounts are disabled unless explicitly enabled

  // TODO: Update AU and CA prices with actual region-specific pricing once available

  return {
    [ShopifyStore.IN]: {
      enabled: process.env.RARE_DISCOUNT_IN === 'true', // Default: false
      discountPercentage: 8.57,
      showStrikedPrice: process.env.RARE_SHOW_STRIKED_IN === 'true', // Default: false
      description: 'Early Bird Discount',
    },
    [ShopifyStore.ROW]: {
      enabled: process.env.RARE_DISCOUNT_ROW === 'true', // Default: false
      discountPercentage: 11.33,
      showStrikedPrice: process.env.RARE_SHOW_STRIKED_ROW === 'true', // Default: false
      description: 'Launch Discount',
    },
    [ShopifyStore.US]: {
      enabled: process.env.RARE_DISCOUNT_US === 'true', // Default: false
      discountPercentage: 11.33,
      showStrikedPrice: process.env.RARE_SHOW_STRIKED_US === 'true', // Default: false
      description: 'Launch Discount',
    },
    [ShopifyStore.AE]: {
      enabled: process.env.RARE_DISCOUNT_AE === 'true', // Default: false
      discountPercentage: 9.15,
      showStrikedPrice: process.env.RARE_SHOW_STRIKED_AE === 'true', // Default: false
      description: 'Launch Discount',
    },
    [ShopifyStore.GB]: {
      enabled: process.env.RARE_DISCOUNT_GB === 'true', // Default: false
      discountPercentage: 8.86,
      showStrikedPrice: process.env.RARE_SHOW_STRIKED_GB === 'true', // Default: false
      description: 'Launch Discount',
    },
    [ShopifyStore.EU]: {
      enabled: process.env.RARE_DISCOUNT_EU === 'true', // Default: false
      discountPercentage: 7.38,
      showStrikedPrice: process.env.RARE_SHOW_STRIKED_EU === 'true', // Default: false
      description: 'Launch Discount',
    },
    [ShopifyStore.AU]: {
      enabled: process.env.RARE_DISCOUNT_AU === 'true', // Default: false
      discountPercentage: 11.33,
      showStrikedPrice: process.env.RARE_SHOW_STRIKED_AU === 'true', // Default: false
      description: 'Launch Discount',
    },
    [ShopifyStore.CA]: {
      enabled: process.env.RARE_DISCOUNT_CA === 'true', // Default: false
      discountPercentage: 11.33,
      showStrikedPrice: process.env.RARE_SHOW_STRIKED_CA === 'true', // Default: false
      description: 'Launch Discount',
    },
    [ShopifyStore.SA]: {
      enabled: process.env.RARE_DISCOUNT_SA === 'true', // Default: false
      discountPercentage: 11.33,
      showStrikedPrice: process.env.RARE_SHOW_STRIKED_SA === 'true', // Default: false
      description: 'Launch Discount',
    },
    [ShopifyStore.MX]: {
      enabled: process.env.RARE_DISCOUNT_SA === 'true', // Default: false
      discountPercentage: 11.33,
      showStrikedPrice: process.env.RARE_SHOW_STRIKED_SA === 'true', // Default: false
      description: 'Launch Discount',
    },
    [ShopifyStore.ZA]: {
      enabled: process.env.RARE_DISCOUNT_SA === 'true', // Default: false
      discountPercentage: 11.33,
      showStrikedPrice: process.env.RARE_SHOW_STRIKED_SA === 'true', // Default: false
      description: 'Launch Discount',
    },
    [ShopifyStore.JP]: {
      enabled: process.env.RARE_DISCOUNT_JP === 'true', // Default: false
      discountPercentage: 11.33,
      showStrikedPrice: process.env.RARE_SHOW_STRIKED_JP === 'true', // Default: false
      description: 'Launch Discount',
    },
  };
};

/**
 * Helper function to check if discounts are enabled for a specific store
 */
export const isRareDiscountEnabled = (store: ShopifyStore): boolean => {
  const config = getRareDiscountConfig();
  return config[store]?.enabled ?? false;
};

/**
 * Helper function to check if striked prices should be shown for a specific store
 */
export const shouldShowRareStrikedPrice = (store: ShopifyStore): boolean => {
  const config = getRareDiscountConfig();
  return config[store]?.showStrikedPrice ?? false;
};

/**
 * Helper function to get discount percentage for a specific store
 */
export const getRareDiscountPercentage = (store: ShopifyStore): number => {
  const config = getRareDiscountConfig();
  return config[store]?.discountPercentage ?? 0;
};
